import { AttachmentUrlIcon } from "@/components";
import { SkeletonMemberList } from "@/components/Skeletons";
import { useGetChat } from "@/hooks";
import { downloadFile, formatDate } from "@/utils";
import React, { useCallback } from "react";
import { BsCloudDownloadFill } from "react-icons/bs";
import { IoArrowBackOutline } from "react-icons/io5";

interface Props {
  roomId: number;
  hiddenSideBar?: () => void;
}
const FileList: React.FC<Props> = ({ roomId, hiddenSideBar }) => {
  const { chat, isLoading } = useGetChat(roomId);
  const attachments = chat?.files;

  // Download file
  const handleDownload = useCallback((url: string, name: string) => {
    downloadFile(url, name);
  }, []);

  if (isLoading) return <SkeletonMemberList type="item" />;

  return (
    <section>
      <div
        className="px-4 !py-2 flex gap-2 items-center h-10 w-fit xl:hidden"
        onClick={hiddenSideBar}
      >
        <IoArrowBackOutline size={16} color="#637381" className="w-5 h-5" />
        <p className="!text-sm text-light_primary font-semibold !leading-5.5">
          添付ファイル
        </p>
      </div>

      <div className="flex flex-col-reverse">
        {attachments?.map((attachment) => (
          <div
            key={attachment.url}
            className="group px-4 py-2 relative flex items-center gap-4 hover:bg-grey-200 transition-colors"
          >
            <div className="size-8 flex items-center justify-center bg-grey-200 rounded-lg">
              <AttachmentUrlIcon
                url={attachment.url}
                classNameByDocumentType={(type) => {
                  if (type !== "document") return "size-8";
                  else return "size-4";
                }}
              />
            </div>
            <div className="flex-1 text-sm leading-5.5 min-w-0">
              <div
                className="text-light_primary truncate"
                title={attachment.name}
              >
                {attachment.name}
              </div>
              <div className="text-light_secondary truncate">
                {formatDate(attachment.date)}
              </div>
            </div>

            {/* Download file  */}
            <button
              type="button"
              className="bg-cyan text-light_default absolute top-1/2 translate-y-[-50%] right-2 p-1 rounded-full invisible group-hover:visible"
              onClick={() => handleDownload(attachment.url, attachment.name)}
            >
              <BsCloudDownloadFill />
            </button>
          </div>
        ))}

        {(!attachments || attachments.length === 0) && (
          <div className="py-2 px-4 text-center text-light_secondary">
            添付ファイルなし
          </div>
        )}
      </div>
    </section>
  );
};

export default FileList;
